export default __webpack_public_path__ + "static/m-service-2-1495712d8778e87086d8fca7bfbba3c4.jpg";